/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Undefined
 *
 * 1 = Divorced (Разведен)
 *
 * 2 = MarriedOrCivilPartnership (Женат/замужем или гражданский брак)
 *
 * 3 = Single
 *
 * 4 = Separated
 *
 * 5 = Cohabiting (Сожительство)
 *
 * 6 = Widowed (Вдава/вдовец)
 */
export enum UserMaritalStatus {
  Undefined = 0,
  /**
   * Разведен
   */
  Divorced = 1,
  /**
   * Женат/замужем или гражданский брак
   */
  MarriedOrCivilPartnership = 2,
  Single = 3,
  Separated = 4,
  /**
   * Сожительство
   */
  Cohabiting = 5,
  /**
   * Вдава/вдовец
   */
  Widowed = 6,
}
